module.exports = __webpack_public_path__ + "img/meituan-coupon-vertify-icon.1a46db84.png";